import { render, staticRenderFns } from "./vEditProfile.vue?vue&type=template&id=760f50f8&"
import script from "./vEditProfile.vue?vue&type=script&lang=js&"
export * from "./vEditProfile.vue?vue&type=script&lang=js&"
import style0 from "./vEditProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports